import { addDays, subDays, startOfDay, startOfWeek } from "date-fns";

import { dayOfWeek, PlanDates } from "types/app";

export const WeekStartsOnValues = {
  Sunday: 0,
  Monday: 1,
  Saturday: 6,
} as const;

export type WeekStartsOn =
  (typeof WeekStartsOnValues)[keyof typeof WeekStartsOnValues];

// plan always has numOfDays % 7 === 0
export function calcPlanDates(
  numWeeksInPlan: number,
  raceDate: Date,
  weekStartsOn: WeekStartsOn,
): PlanDates {
  const lastWeekStart = startOfWeek(raceDate, { weekStartsOn });
  const planStartDate = startOfDay(
    subDays(lastWeekStart, (numWeeksInPlan - 1) * 7),
  );
  const planEndDate = startOfDay(raceDate);
  const start = planStartDate;
  const end = startOfDay(addDays(lastWeekStart, 6));

  return {
    start,
    planStartDate,
    planEndDate,
    end,
    weekCount: numWeeksInPlan,
  };
}

export function getDaysHeader(weekStartsOn: WeekStartsOn): dayOfWeek[] {
  if (weekStartsOn === WeekStartsOnValues.Monday) {
    return [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
  }
  if (weekStartsOn === WeekStartsOnValues.Sunday) {
    return [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
  } else {
    return [
      "Saturday",
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
    ];
  }
}
